const hasResource = (menus, resourceName) => {
  return (
    menus?.findIndex(
      (menu) =>
        menu.resources.findIndex(
          (resource) => resource.resource === resourceName,
        ) !== -1,
    ) !== -1
  );
};

export const getTour = (menus) => {
  const hasScheduleMenu = hasResource(menus, 'schedule');
  const hasServiceAreaMenu = hasResource(menus, 'service-area');

  if (hasScheduleMenu && hasServiceAreaMenu) {
    return 'welcomeTourWithScheduleAndServiceArea';
  }
  if (hasScheduleMenu) {
    return 'welcomeTourWithSchedule';
  }
  if (hasServiceAreaMenu) {
    return 'welcomeTourWithServiceArea';
  }
  // If we somehow don't have either of these menus, this would be a very short tour.
  // We'll just hide the tour instead.
  return null;
};
